var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartLinePremiumsVClaims(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "142px",
    height: "42px",
    viewBox: "0 0 142 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "930AE803-C1D2-4B9B-9E26-86F163F2BE3D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visual-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage---Edit-Metrics---Alternate",
    transform: "translate(-541.000000, -346.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-119",
    transform: "translate(223.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    transform: "translate(61.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(224.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart-line-premiums-v-claims",
    transform: "translate(34.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.150537634,
    y1: 25.625,
    x2: 139.849462,
    y2: 25.625,
    id: "Line-7",
    stroke: "#979797",
    strokeLinecap: "square",
    strokeDasharray: "2,4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-8",
    stroke: "#52B3FD",
    strokeWidth: 2,
    strokeLinejoin: "bevel",
    points: "3 26.637931 18.0281381 10.8970905 29.6229941 30.3448276 36.0980435 20.6896552 46.9399868 40 54.167949 20.6896552 61.6970763 18.6206897 71.6355243 6.89655172 79.7669818 34.9946121 88.8019345 23.4482759 95.3510988 30.3448276 111.637542 6.89655172 120.336429 10.8970905 132.169708 30.3448276 140 0"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLinePremiumsVClaims);
export default __webpack_public_path__ + "static/media/chart-line-premiums-v-claims.547d1ea20d5c412dcad71fbc7b6db9cf.svg";
export { ForwardRef as ReactComponent };